import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import SidebarNav from './sidebarNav';

import { currentUserHasPermission } from '../../util';

import { getIcon } from '../../util/icons';

import { fetchUser, unloadUser } from '../../actions/users';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';

import { WelcomeModal, UnsupportedModal } from '../modals';

class Page extends Component {

  state = {
    pageMessage: null,
    loadingUserData: false,
  }

  renderLoadingContent(){
    return <h6 style={{width: '100%', lineHeight: '50px', textAlign: 'center', fontSize: '24px', color: '#DDDDDD', letterSpacing: '.20em'}}>LOADING...</h6>;
  }

  fetchOrUnloadUserDataAsNecessary(props){

    const { match: { params } } = this.props;

    const employeeId = params.employeeId;

    if(employeeId && (props.viewingUser.id !== params.employeeId)){
      //console.log('fetching user data for new user');
      if(!this.state.loadingUserData && !this.props.viewingUser.id){
        this.props.fetchUser(employeeId);
        this.setState({
          loadingUserData: true,
        });
      }
    }
    else if(!employeeId && props.viewingUser.id){
      //need to UNLOAD user
      //console.log('employee id missing..but we currently have "viewinguser"...need to unload user data');
      this.props.unloadUser();
    }
    else{
      //console.log('not fetching or unloading user');
    }

    if(props.viewingUser && props.viewingUser.data && props.viewingUser.id === employeeId){
      //console.log('user data fetched!');
      this.setState({
        loadingUserData: false,
      });
    }
  }

  componentWillMount(){
    //console.log('PAGE mounting...with props: ', this.props);
    this.fetchOrUnloadUserDataAsNecessary(this.props);
  }

  componentWillReceiveProps(nextProps){

    this.fetchOrUnloadUserDataAsNecessary(nextProps);

    const { pageMessage } = nextProps;

    if(pageMessage){
      this.setState({
        pageMessage
      });

      if(pageMessage.expireAfter){
        setTimeout(() => {
          this.clearMessage();
        }, pageMessage.expireAfter);
      }
    }
  }

  clearMessage(){
    //clear locally and in parent so we don't show it again when receiving new unrelated props

    this.setState({
      pageMessage: null
    });

    this.props.clearMessage();
  }

  renderPageMessage(){

    const { pageMessage } = this.state;

    const visibleClass = (pageMessage ? 'visible' : '');

    return(
      <div className={`page-message-container ${visibleClass}`}>
        {this.renderPageMessageContent()}
      </div>
    )
  }

  renderPageMessageContent(){

    const { pageMessage } = this.state;

    if(!pageMessage){
      return null;
    }

    const { messageContent, messageType } = pageMessage;

    return (
      <div className={`page-message ${messageType}`}>
        <div className="message">{messageContent}</div>
        <div className="action" onClick={this.clearMessage.bind(this)}>{getIcon('cancel')}</div>
        {messageType === 'error' &&
          <React.Fragment>
            <CopyToClipboard text={messageContent}>
              <div className="action" data-tip="Copy error message to clipboard" data-for="copy-error-to-clipboard">{getIcon('copy')}</div>
            </CopyToClipboard>
            <ReactTooltip id="copy-error-to-clipboard" effect="solid" place="bottom"/>
          </React.Fragment>
        }
      </div>
    )
  }

  renderMainContentWithSidebar(){

    const loading = this.props.loading || this.state.loadingUserData;

    if(this.props.customSidebar){
      return (
        <div className="content-wrapper">
          {this.props.customSidebar}
          <div className="page-main-content has-sidebar-nav">
            {this.renderPageMessage()}
            {loading && this.renderLoadingContent()}
            {!loading && this.props.children}
          </div>
        </div>
      );
    }
    else{
      return (
        <div className="content-wrapper">
          <SidebarNav />
          <div className="page-main-content has-sidebar-nav">
            {this.renderPageMessage()}
            {loading && this.renderLoadingContent()}
            {!loading && this.props.children}
          </div>
        </div>
      );
    }
  }
  renderMainContentWithoutSidebar(){

    const loading = this.props.loading || this.state.loadingUserData;

    return (
      <div className="content-wrapper">
          <div className="page-main-content">
            {this.renderPageMessage()}
            {loading && this.renderLoadingContent()}
            {!loading && this.props.children}
          </div>
      </div>
    );
  }
  render(){

    const pageClass = this.props.pageClass || '';
    const hideSidebar = this.props.hideSidebar;
    const customSidebar = this.props.customSidebar;
    const permissionRequired = this.props.permissionRequired;

    if(permissionRequired && !currentUserHasPermission(permissionRequired)){
      return(
        <div className="page restricted">
          <div className="content-wrapper">
            <div className="page-main-content">
              {getIcon('lock')}
              <p style={{ width: '100%', textAlign: 'center' }}>Insufficient permissions</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={'page ' + pageClass}>
        {(!hideSidebar || customSidebar) && this.renderMainContentWithSidebar()}
        {hideSidebar && !customSidebar && this.renderMainContentWithoutSidebar()}
        <WelcomeModal user={this.props.user} />
        <UnsupportedModal />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps){
  return {
    user: state.user,
    viewingUser: state.viewingUser,
    route: ownProps.location.pathname,
  }
}

export default withRouter(connect(mapStateToProps, { fetchUser, unloadUser })(Page));



// WEBPACK FOOTER //
// ./src/components/shared/page.js